import { TickItem } from '../../Profile/Positions/elements';

interface PriceRangeCardProps {
  title: string;
  tick: number;
  subtitle: string;
}

export const PriceRangeCard = ({
  title,
  tick,
  subtitle,
}: PriceRangeCardProps) => {
  return (
    <div className="flex-1 bg-gray-50 border border-gray-300 rounded-lg p-3 text-center space-y-2">
      <h5 className="font-medium text-sm">{title}</h5>
      <div className="text-lg">
        <TickItem tick={tick} />
      </div>
      <div className="text-gray-500 text-xs">{subtitle}</div>
    </div>
  );
};
